export const experiences = [
  {
    role: "Technical Support Engineer",
    company: "@Filevine, Inc",
    duration: "February 2026 - Present",
    responsibilities: [
      "Delivered live technical support by diagnosing application, and workflow issues through developer console network logs, REST requests, and New Relic inspection, maintaining a 91% resolution rate",
      "Investigated application and workflow defects through New Relic traces, error logs, isolated affected services by controlled replication, reducing complex-case resolution time by an estimated 20%",
      "Secured sensitive legal data through least-privilege access, authorization validation, and sanitized diagnostics, maintaining 100% privacy and security compliance",
    ],
  },
  {
    role: "System Engineer",
    company: "@Ensign College",
    duration: "June 2025 - December 2025",
    responsibilities: [
      "Delivered Tier 2 support by diagnosing API and workflow issues, reducing resolution time by 75%, completing 95% of tickets without escalation and strengthening overall system stability",
      "Built a serverless automation service using Jira, AWS Lambda, API Gateway, and CRM integrations, cutting ticket handling by 80%, achieving 94% automation coverage, and full cross-system traceability",
      "Developed an NLP bot for Meta Suite, reducing conversation handling to 5 minutes, improving routing accuracy, and increasing lead capture by 20% through enhanced intent-detection logic",
    ],
  },
  {
    role: "DevOps Engineer",
    company: "@Good Samaritan Foundation",
    duration: "August 2023 - August 2025",
    responsibilities: [
      "Managed and secured domain services for 20+ users by configuring access roles, authentication protocols, and group policies, maintaining 98% system uptime and stable daily operations",
      "Conducted monthly audits and deployed system patches across cloud and local infrastructure, reducing vulnerabilities by 30% and improving compliance with best security practices",
      "Implemented and enforced access control policies across cloud and on-prem systems, minimizing unauthorized access incidents by 40%",
      "Automated user provisioning and system updates with shell scripts and scheduling tools, cutting manual IT hours by 25% and improving system reliability",
    ],
  },
  {
    role: "Call Center Specialist",
    company: "@Ensign College",
    duration: "June 2022 - August 2022",
    responsibilities: [
      "Engaged 30+ prospective students daily through structured call flows and follow-up, achieving an 98% contact rate within 48 hours",
      "Implemented and trained peers on an AI chatbot integrated into CRM, reducing manual responses and improving contact efficiency by 50%",
      "Maintained accurate call logs using standardized data entry protocols, ensuring 100% record accuracy and policy compliance",
      "Partnered with admissions to streamline onboarding touchpoints, improving first-response time and student engagement",
      "Adjusted outreach strategies based on call analytics, reducing missed connections by 35%",
    ],
  },
];
